import { Badge } from '../catalyst/badge'
import type { AdminPesticideRow, PesticideReviewState } from '../lib/types'
import { ListPage } from './list-page'
import { ReviewBadge } from './review'

export function ReviewStateBadge({ state }: { state: PesticideReviewState }) {
  switch (state) {
    case 'none':
      return <Badge color="zinc">No label fetched</Badge>
    case 'not_found':
      return <Badge color="zinc">No label on file</Badge>
    case 'unstructured':
      return <Badge color="zinc">Not read yet</Badge>
    default:
      return <ReviewBadge status={state} />
  }
}

export function PesticidesPage() {
  return (
    <ListPage<AdminPesticideRow>
      title="Pesticides"
      description="The Health Canada PPID registry as Farmula holds it. Registry fields are synced and read-only; the label facts growers see are what you review and correct."
      path="/admin/pesticides"
      noun="pesticides"
      rowHref={(p) => `/pesticides/${p.id}`}
      filter={{
        param: 'review',
        label: 'Review state',
        initial: 'unreviewed',
        options: [
          { value: '', label: 'All' },
          { value: 'unreviewed', label: 'Needs review' },
          { value: 'approved', label: 'Reviewed' },
          { value: 'rejected', label: 'Rejected' },
          { value: 'unstructured', label: 'Label not read yet' },
          { value: 'not_found', label: 'No label on file' },
          { value: 'none', label: 'No label fetched' },
        ],
      }}
      columns={[
        { header: 'Name', primary: true, cell: (p) => p.productNameEn },
        { header: 'Registration #', cell: (p) => p.registrationNumber },
        { header: 'Active ingredient', cell: (p) => p.activeIngredientsRawEn || '—' },
        { header: 'Registry', cell: (p) => <Badge color={p.currentOrHistorical === 'Current' ? 'green' : 'zinc'}>{p.currentOrHistorical}</Badge> },
        {
          header: 'Label review',
          cell: (p) => (
            <span className="flex flex-wrap gap-1">
              <ReviewStateBadge state={p.reviewState} />
              {p.curated && <Badge color="blue">Edited by staff</Badge>}
            </span>
          ),
        },
      ]}
    />
  )
}
